import React from "react"

import { useAuth0 } from "@auth0/auth0-react"

import {
  Avatar,
  AvatarImage,
  Box,
  HStack,
  Icon,
  Menu,
  MenuItem,
  MenuItemLabel,
  Pressable,
  Text,
} from "wealthmode-frontend/gluestack/ui"
import { LogOutIcon } from "wealthmode-frontend/icons"

const AppHeaderDropdown = () => {
  const { user } = useAuth0()
  return (
    <Menu
      placement="bottom right"
      offset={8}
      className="bg-background-secondary border-border-dark shadow-lg"
      trigger={(triggerProps: any) => (
        <Pressable
          {...triggerProps}
          className="p-0"
        >
          <Avatar size="md">
            <AvatarImage
              source={{ uri: user?.picture }}
              alt={user?.name || "User"}
            />
          </Avatar>
        </Pressable>
      )}
    >
      <Box className="bg-background-tertiary font-semibold mb-2 px-3 py-2 -mx-1 -mt-1 rounded-t">
        <Text className="font-semibold text-foreground-secondary">Account</Text>
      </Box>
      <MenuItem
        className="data-[hover=true]:bg-background-tertiary data-[active=true]:bg-background-tertiary"
        onPress={() => (window.location.href = "/auth/logout")}
      >
        <HStack className="items-center gap-2">
          <Icon
            as={LogOutIcon}
            className="text-foreground-tertiary h-9 w-9"
          />
          <MenuItemLabel className="text-foreground-primary">Logout</MenuItemLabel>
        </HStack>
      </MenuItem>
    </Menu>
  )
}

export default AppHeaderDropdown
